<template lang="pug">
  b-container.content-wrap(fluid :class="{ 'is-mobile': isMobile }")
    b-container.d-flex.justify-content-between(fluid)
      .title
        span.page-title {{$t('remote.remote.title')}} {{$t('history')}}
        //- b-button(variant="link", size="sm", style="padding: 0.25rem 0.7rem;", target="_blank", href="https://linkmemine.co.kr/faq/p/manager_guide_topic_07.php")
          //icon(name="bookmark", style="margin:0 4px 0 2px;")
          span {{$t('tutorial-statistics')}}
    
    b-row.search-form
      b-col.mmb-10(cols="12" lg="2")
        b-form-select(v-model="form.date_type" :options="selectOptions.date" size="sm")
      b-col.mmb-10(cols="6" lg="2")
        b-form-datepicker(
          v-model="range.start"
          :bootstrap-styling="true"
          :language="range.lang"
          :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
          format="yyyy-MM-dd"
          size="sm"
          @input="search"
        )
      b-col.mmb-10(cols="6" lg="2")
        b-form-datepicker(
          v-model="range.end"
          :bootstrap-styling="true"
          :language="range.lang"
          :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
          format="yyyy-MM-dd"
          size="sm"
          @input="search"
        )
      b-col.mmb-10(cols="12" lg="4")
        b-input-group
          b-input-group-prepend
            b-form-select.mr-2(v-model="form.selected" :options="selectOptions.list" size="sm" @change="changeSearchSelect")
          b-form-input(v-if="selectInput.type === 'keyword'" size="sm" v-model="form.value" @keypress.enter="search")
          b-form-select.mr-2(v-if="selectInput.type === 'select'" v-model="form.value" :options="selectInput.list" size="sm")
          b-input-group-append
            b-btn(size="sm" @click="search") {{$t('search')}}

      b-col.right-btns
        //- b-btn.ml-2.view-mode-button(size="sm" target="_blank" href="https://linkmemine.co.kr/faq/p/manager_guide_topic_07.php")
        b-btn.ml-2.view-mode-button(size="sm", :disabled="excelLoaded" @click="downloadExcel")
          img.mr-1(:src="`${AppState.Path.image}/icons/excel-icon.svg`" style="height: 0.9rem; vertical-align: middle;")
          span(v-if="!excelLoaded") {{$t('excel_button')}}
          span(v-else) Download...

    b-card.table-card
      b-table(
        ref="dataTable",
        :fields="dynamicFields"
        :items="fetchList"
        :current-page="tableData.pagination.current"
        :per-page="tableData.pagination.limit"
        :empty-text="$t('no-content')",
        tbody-class="lmm-table-body",
        sort-by="start_time"
        :sort-desc="true"
        show-empty
        responsive
      )
        template(v-slot:cell(start_time)="data")
          | {{data.item.start_time| moment('YY-MM-DD HH:mm')}}
        template(v-slot:cell(end_time)="data")
          span(v-if="data.item.end_time !== 'None'") {{data.item.end_time | moment('YY-MM-DD HH:mm')}}

        template(v-slot:cell(reg_mail)="row")
          b-btn(variant="link" :to="{name: 'edit-manager', params: {userPk: row.item.reg_pk}}") {{row.item.reg_mail}}
        
        template(v-slot:cell(reg_name)="row")
          b-btn(variant="link" :to="{name: 'edit-manager', params: {userPk: row.item.reg_pk}}") {{row.item.reg_name}}

        template(v-slot:cell(flag_use_approval)="row")
          span {{ kindFilter(row.item.flag_use_approval) }}

        template(v-slot:cell(host_os_id)="row")
          span {{ row.item.host_os_id | osPrint }}
        
        template(v-slot:cell(viewer_os_id)="row")
          span {{ row.item.viewer_os_id | osPrint }}

        template(v-slot:cell(record_file_path)="row")
          b-link(v-if="row.item.record_file_path" @click="openVideo(row.item.record_file_path)") O
          span(v-else) X

        template(v-slot:cell(flag_agreement)="row")
          b-link(v-if="row.item.flag_agreement" @click="openContract(row.item)") O
          span(v-else) X
    //- pagination
    .pagination-wrap
      div
        b-form-select(
          size="sm"
          v-model="tableData.pagination.limit"
          :options="tableData.pagination.perOptions"
        )
      b-pagination(
        size="sm"
        v-model="tableData.pagination.current"
        :total-rows="tableData.pagination.total"
        :per-page="tableData.pagination.limit"
        class="my-0 float-right"
      )

    dialog-contract(:show.sync="showContract" :form="contractForm" :isAdd="false")
</template>

<script>
import { AnalysticAPI, SecurityAgreementAPI, GetMgridAPI} from "@/api"
import moment from "moment"
import _ from "lodash"
import { getCurrentLanguage } from "@/i18n"
import * as datePickerLocale from "vuejs-datepicker/dist/locale"
import Datepicker from "vuejs-datepicker"
import Switches from "vue-switches"
import DialogContract from "@/components/management/function-settings/components/dialog/dialogSettingContract/form.vue"
import store from '@/api/store'

export default {
  name: "log-remote-component",
  components: { Datepicker, Switches, DialogContract },
  computed: {
    selectInput() {
      return _.find(this.selectOptions.list, { value: this.form.selected })
    },
    isMobile() {
      if (!this.$mq) return false
      if (this.$mq.resize && this.$mq.isMobile()) return true
      return false
    },
    accountType() {
      return store.get('auth').account_type
    },
    dynamicFields() {
      const baseFields = [
        { key: "reg_mail", label: this.$t('ID'), sortable: true, thStyle: { minWidth: "120px" }, tdClass: "text-nowrap" },
        { key: "reg_name", label: this.$t('account-manage'), sortable: true, thStyle: { minWidth: "120px" }, tdClass: "text-nowrap" },
        { key: "start_time", label: this.$t('start_datetime'), sortable: true, thStyle: { minWidth: "130px" }, tdClass: "text-nowrap" },
        { key: "end_time", label: this.$t('end_datetime'), sortable: true, thStyle: { minWidth: "130px" }, tdClass: "text-nowrap" },
        { key: "flag_use_approval", label: this.$t('category'), sortable: true, thStyle: { minWidth: "70px" }, tdClass: "text-nowrap" },
        { key: "device_name", label: `${this.$t('remote_device')} ${this.$t('name')}`, sortable: true, thStyle: { minWidth: "220px" }, tdClass: "text-nowrap" },
        { key: "host_os_id", label: `${this.$t('remote_device')} OS`, sortable: true, thStyle: { minWidth: "120px" }, tdClass: "text-nowrap" },
        { key: "host_public_ip", label: `${this.$t('remote_device')} IP`, sortable: true, thStyle: { minWidth: "120px" }, tdClass: "text-nowrap" },
        { key: "manager_device_name", label: `${this.$t('manager_str')} ${this.$t('name')}`, sortable: true, thStyle: { minWidth: "170px" }, tdClass: "text-nowrap" },
        { key: "viewer_os_id", label: `${this.$t('manager_str')} OS`, sortable: true, thStyle: { minWidth: "120px" }, tdClass: "text-nowrap" },
        { key: "viewer_public_ip", label: `${this.$t('manager_str')} IP`, sortable: true, thStyle: { minWidth: "120px" }, tdClass: "text-nowrap" },
        { key: "record_file_path", label: this.$t('recording'), sortable: true, thStyle: { minWidth: "90px" }, tdClass: "text-nowrap" },
      ]
      
      if (this.accountType === 1) {
        const additionalFields = [
          { key: "flag_agreement", label: this.$t('pledge'), sortable: true, thStyle: { minWidth: "90px" }, tdClass: "text-nowrap" },
          { key: "security_agreement_version", label: this.$t('pledge_version'), sortable: true, thStyle: { minWidth: "110px" }, tdClass: "text-nowrap" },
          { key: "sl_error_code", label: this.$t('error_code'), sortable: true, thStyle: { minWidth: "110px" }, tdClass: "text-nowrap" },
          { key: "reason", label: this.$t('application_reason'), sortable: true, thStyle: { minWidth: "200px" }, tdClass: "text-nowrap" },
        ]
        
        baseFields.push(...additionalFields)
      }
      
      return baseFields
    },
    kindFilter() {
      return (value) => {
        return value ? this.$t('approval_process') : this.$t('exception')
      }
    },
  },
  filters: {
    osPrint(value) {
      return {
        0: "UNKNOWN",
        1: "Windows",
        2: "Linux",
        3: "OS_X",
        4: "Android",
        5: "iOS",
      }[value]
    },
  },
  data() {
    let disabledDateInit = new Date()
    disabledDateInit.setDate(-1)
    return {
      showContract: false,
      contractForm: {
        security_agreement_version: "",
        content: "",
      },
      contractList: [],

      form: {
        date_type: "start_time",
        selected: "reg_mail",
        value: "",
      },
      selectOptions: {
        date: [
          { text: this.$t('start_datetime'), value: "start_time" },
          { text: this.$t('end_datetime'), value: "end_time" },
        ],
        list: [
          { text: this.$t('ID'), value: "reg_mail", type: "keyword" },
          { text: this.$t('account-manage'), value: "reg_name", type: "keyword" },
          {
            text: this.$t('category'),
            value: "flag_use_approval",
            type: "select",
            list: [
              { text: this.$t('total'), value: "" },
              { text: this.$t('exception'), value: "0" },
              { text: this.$t('approval_process'), value: "1" },
            ],
          },
          { text: `${this.$t('remote_device')} ${this.$t('name')}`, value: "device_name", type: "keyword" },
          {
            text: `${this.$t('remote_device')} OS`,
            value: "host_os_id",
            type: "select",
            list: [
              { text: this.$t('total'), value: "" },
              { text: "Windows", value: "1" },
            ],
          },
          { text: `${this.$t('remote_device')} IP`, value: "host_public_ip", type: "keyword" },
          { text: `${this.$t('manager_str')} ${this.$t('name')}`, value: "manager_device_name", type: "keyword" },
          {
            text: `${this.$t('manager_str')} OS`,
            value: "viewer_os_id",
            type: "select",
            list: [
              { text: this.$t('total'), value: "" },
              { text: "Windows", value: "1" },
              { text: "Android", value: "4" },
            ],
          },
          { text: `${this.$t('manager_str')} IP`, value: "viewer_public_ip", type: "keyword" },
          {
            text: this.$t('recording'),
            value: "record_file_path",
            type: "select",
            list: [
              { text: this.$t('total'), value: "" },
              { text: "O", value: "1" },
              { text: "X", value: "0" },
            ],
          },
          { text: this.$t('pledge_version'), value: "flag_agreement", type: "keyword" },
          { text: this.$t('error_code'), value: "sl_error_code", type: "keyword" },
          { text: this.$t('application_reason'), value: "reason", type: "keyword" },
        ],
      },
      excelLoaded: false,
      excelLink: null,
      range: {
        start: moment()
          .add(-14, "days")
          .toDate(),
        end: moment().toDate(),
        disabledDates: { to: disabledDateInit },
        lang: datePickerLocale[getCurrentLanguage()],
      },

      tableData: {
        list: [],
        pagination: {
          by: "start_time",
          limit: 24,
          offset: 0,
          order: "desc",

          date_type: "start_time",
          start_date: moment()
            .add(-14, "days")
            .format("YYYY-MM-DD"),
          end_date: moment().format("YYYY-MM-DD"),

          reqeust_type: 3,

          search_mode: "pagination",

          total: 0,
          current: 1,
          perOptions: [
            { value: 12, text: "12" },
            { value: 24, text: "24" },
            { value: 36, text: "36" },
          ],
        },
      },
    }
  },
  mounted() {
    this.fetchContract()
  },
  methods: {
    openContract(item) {
      this.contractForm = {
        security_agreement_version: item.security_agreement_version,
        content: _.find(this.contractList, { security_agreement_version: item.security_agreement_version }).content,
      }
      this.showContract = true
    },
    fetchContract() {
      SecurityAgreementAPI.get().then(res => {
        const { data } = res
        this.contractList = data.objects
      })
    },
    fetchList(ctx) {
      if (ctx.sortBy === "") return

      this.tableData.pagination.by = ctx.sortBy
      this.tableData.pagination.limit = ctx.perPage
      this.tableData.pagination.order = ctx.sortDesc ? "desc" : "asc"
      this.tableData.pagination.offset = (this.tableData.pagination.current - 1) * this.tableData.pagination.limit

      const params = {
        by: this.tableData.pagination.by,
        limit: this.tableData.pagination.limit,
        offset: this.tableData.pagination.offset,
        order: this.tableData.pagination.order,

        start_date: this.tableData.pagination.start_date,
        end_date: this.tableData.pagination.end_date,

        request_type: this.tableData.pagination.reqeust_type,

        date_type: this.tableData.pagination.date_type,
        search_key: this.tableData.pagination.search_key,
        search_value: this.tableData.pagination.search_value,
        search_mode: "pagination",

        export_id: "remoteHistoryTable",
      }

      return AnalysticAPI.history.get("remote", { params }).then(res => {
        const { objects, meta, status } = res.data
        if (status !== 200) {
          this.$awn.warning(this.$t('toasts_message.data_fetch_failed'))
          return []
        }

        this.tableData.list = objects
        this.tableData.pagination.total = meta.total_count

        return this.tableData.list
      })
    },

    async downloadExcel() {
      this.excelLoaded = true
      const params = await this.fetchExcel()
      .then(params=>
      {
        //전송용 임시 폼 엘리먼트 생성
        var form = document.createElement('form');
        form.method = 'post';
        form.action = "/download/excel.html"; // /download/excel.html을 통해 DownloadExcelFileAPI호출

        // 엑셀 생성에 필요한 필터된 데이터를 폼에 추가
        let jsonData = {...params, language: this.$i18n.locale}
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'jsondata';
        input.value = JSON.stringify(jsonData);
        form.appendChild(input);

        // body에 폼 추가 및 제출 그 후 제거
        document.body.appendChild(form);
        form.target = '_blank';
        form.submit();
        document.body.removeChild(form);

        this.excelLoaded = false
      })
      .catch(err => {
        this.excelLoaded = false
        alert(this.$t('toasts_message.no_data_to_download_excel'))
        return
      })
    },

    async fetchExcel() {
      let params = {
        by: this.tableData.pagination.by,
        limit: 0,
        offset: 0,
        order: this.tableData.pagination.order,

        start_date: this.tableData.pagination.start_date,
        end_date: this.tableData.pagination.end_date,

        request_type: this.tableData.pagination.reqeust_type,

        date_type: this.tableData.pagination.date_type,
        search_key: this.tableData.pagination.search_key,
        search_value: this.tableData.pagination.search_value,
        search_mode: "pagination",

        export_id: "remoteHistoryTable",
      }

      if (this.tableData.pagination.total < 1) {
        throw new Error(this.$t('no_data_available'))
      }
      const list = await AnalysticAPI.history.get("remote", { params })

      const excelParams = list.data
      excelParams.excel_doc_title = this.$t('statistics_page.remote_control_history_statistics')

      //console.log(excelParams.objects)
      const { data } = await GetMgridAPI.get("")
      const excelParams_for_download = {
        api: excelParams.api,
        excel_doc_title: "",
        pagename: "",
        mgrid: data.objects.mgrid,
        objects: this.downloaded_excel_data_form(excelParams.objects),
      }
      excelParams_for_download.pagename = "log_remote"
      excelParams_for_download.excel_doc_title = this.$t('statistics_page.remote_control_history_statistics')

      return excelParams_for_download;
    },
    downloaded_excel_data_form(input) {
      let originalLocale = this.$i18n.locale
      this.$i18n.locale = "ko"
      
      //input = excelParams.objects
      let output = []
      let flag_auto_record = {
        "1": "O",
        "0": "X",
      }
      let post_approval = {
        "0": this.$t('prior'),
        "1": this.$t('post'),
        "2": this.$t('exception'),
      }
      let os_id = {
        "0": "UNKNOWN",
        "1": "Windows",
        "2": "Linux",
        "3": "OS_X",
        "4": "Android",
        "5": "iOS",
      }
      let flag_use_approval = {
        true: this.$t('approval_process'),
        false: this.$t('exception'),
      }
      for (let index = 0; index < input.length; index++) {
        let obj = {
          [this.$t('ID')]: input[index]["reg_mail"],
          [this.$t('account-manage')]: input[index]["reg_name"],
          [this.$t('start_date_str')]: this.Date_time_split(input[index]["start_time"])[0],
          [this.$t('start_time')]: this.Date_time_split(input[index]["start_time"])[1],
          [this.$t('end_date')]: this.Date_time_split(input[index]["end_time"])[0],
          [this.$t('end_time')]: this.Date_time_split(input[index]["end_time"])[1],
          // 구분: post_approval[input[index]["post_approval"]],
          [this.$t('category')]: flag_use_approval[input[index]["flag_use_approval"]],
          [this.$t('remote_device')]: input[index]["device_name"],
          [`${this.$t('remote_device')} OS`]: os_id[input[index]["host_os_id"]],
          [`${this.$t('remote_device')} IP`]: input[index]["host_public_ip"],
          [this.$t('manager_str')]: input[index]["manager_device_name"],
          [`${this.$t('manager_str')} OS`]: os_id[input[index]["viewer_os_id"]],
          [`${this.$t('manager_str')} IP`]: input[index]["viewer_public_ip"],
          [this.$t('recording')]: this.filter_record_file_path(input[index]["record_file_path"]),
          [this.$t('pledge')]: "O",
          [this.$t('pledge_version')]: input[index]["security_agreement_version"],
          [this.$t('error_code')]: input[index]["sl_error_code"],
          [this.$t('application_reason')]: input[index]["reason"],
        }
        let obj2 = Object.fromEntries(Object.entries(obj).map(([key, value]) => [key, this.nullcheck(value)]))
        output.push(obj2)
      }
      this.$i18n.locale = originalLocale
      return output
    },
    nullcheck(input) {
      return input == null ? "-" : input
    },
    filter_record_file_path(input)
    {
      return input == null ? "X" : "O"
    },
    Date_time_split(input) {
      let return_array = []
      if (input != "-") {
        let input_array = input.split("T")
        return_array[0] = input_array[0]
        return_array[1] = input_array[1]
          .split(":")
          .slice(0, 2)
          .join(":")
      } else {
        return_array[0] = "-"
        return_array[1] = "-"
      }
      return return_array
    },

    search() {
      this.tableData.pagination.start_date = moment(this.range.start).format("YYYY-MM-DD")
      this.tableData.pagination.end_date = moment(this.range.end).format("YYYY-MM-DD")
      this.tableData.pagination.current = 1
      this.tableData.pagination.date_type = this.form.date_type
      this.tableData.pagination.search_key = this.form.selected
      this.tableData.pagination.search_value = this.form.value
      this.$refs.dataTable.refresh()
    },

    changeSearchSelect() {
      if (this.selectInput.type === "select") {
        this.form.value = this.selectInput.list[0].value
      } else {
        this.form.value = ""
      }
    },
    keyChangeHandler() {
      this.form.value = ""
    },
    startDateChanged(date) {
      this.range.start = date
      this.range.disabledDates.to = date
    },
    endDateChanged(date) {
      this.range.end = date
    },
    tableRefresh() {
      this.page.current = 1
      this.$refs.dataTable.refresh()
    },

    openVideo(path) {
      window.open(`${this.AppState.Path.video}/${path}`, "_blank", "width=600, height=600")
    },
  },
}
</script>

<style lang="scss" scoped></style>
